define('app/views/vendor_rating_form_view',['app/setup'], function(takhfifan) {

  takhfifan.VendorRatingFormView = Backbone.View.extend({
    events: {
      "submit form" : "submitForm"
    },
    initialize: function() {
      this.$el.removeClass('loading-view');
    },

    submitForm: function (e) {
      e.preventDefault();
      var $target = $(e.target),
          formValues = $target.serializeArray(),
          isValid = this.validateForm(formValues),
          _this = this;

      if(isValid){
        formValues.push({name:'form_key', value: takhfifan.formKey});

        this.$el.addClass('loading-view');

        $.ajax({
          url: $target.prop('action'),
          type: $target.prop('method'),
          data: formValues
        }).done(function (data) {
          alert("باتشکر... شما به صفحه اصلی هدایت خواهید شد");
          window.location.replace("/");
        }).fail(function () {
          alert("در برقراری ارتباط خطایی پیش آمد");
        }).always(function () {
          _this.$el.removeClass('loading-view');
        });
      }else{
        alert("لطفا یک گزینه را انتخاب کنید");
      }
    },

    validateForm: function (data) {
      var isValid = false;
      _.each(data,function (item) {
        if(item.value){
          isValid = true;
        }
      });
      return isValid
    }
  });

});

